import { Box, Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  description?: string;
};

export function EmptyState({ title, description }: Props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200 }}>
      <Stack alignItems="center" spacing={1} textAlign="center">
        <Typography variant="h5" fontWeight={700}>
          {title}
        </Typography>
        {description && <Typography color="textSecondary">{description}</Typography>}
      </Stack>
    </Box>
  );
}
